module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"parent_reviews":"Previous review","more_reviews":{"true":"Show {0} reviews","false":"Hide {0} reviews"}}}')
  delete Component.options._Ctor
}
